/* eslint-disable @nx/enforce-module-boundaries */
'use client'

import dayjs from 'dayjs'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { allLangs } from './all-langs'
import type { LanguageValue } from './locales-config'
import { changeLangMessages as messages, fallbackLng } from './locales-config'
import { useRouter } from 'next/navigation'
import { toast } from 'react-toastify'

// --------------------------------------------------------------------------------------------- //

export function useTranslate(ns?: string) {
  const router = useRouter()
  const { t, i18n } = useTranslation(ns)

  const fallback = allLangs.filter(lang => lang.value === fallbackLng)[0]
  const currentLang = allLangs.find(lang => lang.value === i18n.resolvedLanguage)

  const onChangeLang = useCallback(
    async (newLang: LanguageValue, showToast?: boolean) => {
      try {
        await i18n.changeLanguage(newLang)

        const currentMessages = messages[newLang] || messages.en

        if (showToast !== false) {
          toast.success(currentMessages.success)
        }

        if (currentLang) {
          dayjs.locale(currentLang?.adapterLocale)
        }

        router.refresh()
      } catch (error) {
        if (showToast !== false) {
          toast.error(error?.message)
        }
        console.error(error)
      }
    },
    [currentLang, i18n, router]
  )

  return {
    t,
    i18n,
    onChangeLang,
    currentLang: currentLang ?? fallback
  }
}
